module.exports = __webpack_public_path__ + "src/img/verify-fail.b0840f13.svg";